'use client'

import { useSyncExternalStore } from 'react'

/** Largura abaixo da qual a loja usa o layout mobile do menu e do perfil. */
export const MOBILE_MAX_WIDTH = 780

const subscribe = (onChange: () => void) => {
    window.addEventListener('resize', onChange)
    return () => window.removeEventListener('resize', onChange)
}

/**
 * Janela mais estreita que `MOBILE_MAX_WIDTH`, acompanhando o resize. No servidor (e na hidratação) é `false`; o React
 * troca pelo valor do navegador logo depois, sem setState em efeito.
 */
export function useIsMobile(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => window.innerWidth < MOBILE_MAX_WIDTH,
        () => false,
    )
}
